import {
  GET_LOOKUP_DISTRICT_OK,
  GET_LOOKUP_DISTRICT_ERR,
} from "./lookup-district.action";

const InitState = {
  error: null,
  content: null,
};

export default function LookupDistrictReducer(state = InitState, action) {
  switch (action.type) {
    case GET_LOOKUP_DISTRICT_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_LOOKUP_DISTRICT_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
